module.exports = __webpack_public_path__ + "static/img/cadrage_bg.9c22190.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cadrage_bg.jpg
// module id = m5w8
// module chunks = 1